import Vue from 'vue';
import rootStore from '@/store';
import * as types from './mutation-types';
import { compileAsyncMutations } from '@/utils/async';

const mutations = {

  [types.SET_MEETING_DATA](state, payload) {
    Vue.set(state, 'meetingData', payload.meeting);
    state.isMeetingSpectator = payload.isMeetingSpectator;
    state.isMeetingInProgress = payload.meeting !== null;
  },

};

// For each async mutations, dynamically add three mutations
// See @/utils/async for more details
compileAsyncMutations(mutations, types);

export default mutations;
